( ($) => {

    $('.carousel-specifications').on('initialized.owl.carousel', function () {
        // var image_active = $(this).find('.owl-item.active .img_spec');

        // let button = $('.clone-specifications .btn-version[data-version=0]');
        spec_button(0);
    });

    // $(document).on('fullpage-loaded', function (e, section) {
    //
    // });

    $('.clone-specifications .btn-version').on('click', function (e) {
        e.preventDefault();

        let that = $(this);
        if (that.is(':not(.active)')){
            // spec_acitve_button(that);
            let version = that.data('version');
            spec_button(version);
        }
    });

    function spec_button(version){

        let button = $('.clone-specifications .btn-version[data-version='+ version +']');

        // Active button
        $('.clone-specifications .btn-version').removeClass('active');
        button.addClass('active');

        // Active content
        $('.clone-specifications .ATM').addClass('d-none');
        $('.clone-specifications .ATM[data-version=' + version + ']').removeClass('d-none');

        $('.carousel-specifications').addClass('d-none');
        $('.carousel-specifications[data-version=' + version + ']').removeClass('d-none');

        // spec_acitve_button(version);
    }

    function spec_acitve_button(versionActive) {
        // let versionActive = button.data('version');


    }

    $(document).ready(() => {
        $('.scrollbar-info').scroll(function (e) {
            e.stopPropagation();
        });

    });
})(jQuery);